import React from 'react'
import SEOHead from '../components/shared/SEOHead'
import { getPageSEO } from '../utils/seoConfig'
import OnboardingContainer from '../components/onboarding/OnboardingContainer'

const OnboardingPage: React.FC = () => {
  return (
    <>
      <SEOHead seo={getPageSEO("onboarding")} />
      <OnboardingContainer />
    </>
  )
}

export default OnboardingPage
